import React, { useEffect, useState } from 'react';
import { MapPin, X } from 'lucide-react';
const names = ['Juan M.', 'Matias G.', 'Lucas P.', 'Federico R.', 'Tomas S.', 'Ignacio L.', 'Agustin C.', 'Nicolas B.', 'Facundo D.', 'Martin V.'];
const cities = ['CABA', 'Rosario', 'Córdoba', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring interval
    const interval = setInterval(showPopup, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-278">
      <div className="bg-white rounded-lg shadow-xl border border-green-100 p-4 pr-10 relative flex items-start gap-4 max-w-sm" data-id="element-279">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-280">
          <X className="w-4 h-4" data-id="element-281" />
        </button>

        <div className="w-12 h-16 bg-green-800 rounded flex-shrink-0 flex items-center justify-center shadow-inner overflow-hidden relative" data-id="element-282">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1579952363873-27f3bade9f55?q=80&w=100&auto=format&fit=crop')] bg-cover bg-center opacity-40 mix-blend-overlay" data-id="element-283"></div>
          <span className="text-white font-bold text-xs z-10 text-center leading-tight" data-id="element-284">
            FUTBOL
            <br data-id="element-285" />
            PRO
          </span>
        </div>

        <div data-id="element-286">
          <p className="text-sm text-gray-800 font-medium" data-id="element-287">
            <span className="font-bold" data-id="element-288">{purchaseData.name}</span> compró Futbol
            Explosivo Pro
          </p>
          <div className="flex items-center gap-1 mt-1 text-xs text-gray-500" data-id="element-289">
            <MapPin className="w-3 h-3 text-green-600" data-id="element-290" />
            <span data-id="element-291">{purchaseData.city}, Argentina</span>
            <span className="mx-1" data-id="element-292">•</span>
            <span data-id="element-293">{purchaseData.time}</span>
          </div>
        </div>
      </div>
    </div>;
}